var exports = {
  "k": "EmojiPickerSearchBar.module__container___WkY3WF",
};

module.exports = exports;
